import {
  Module,
  VuexModule,
  MutationAction,
  Mutation,
  Action
} from "vuex-module-decorators";
import ApiFactory from "@/api/ApiFactory";

export enum LoadingState {
  working,
  success,
  failure
}

export class LoadingSpinnerConfig {
  visible: boolean = false;
  message?: string;
  state?: LoadingState;
}

export interface ILoadingSpinnerState {
  loadingSpinnerConfig: LoadingSpinnerConfig;
  displayTimestamp: number;
}

const MIN_UP_TIME_MS: number = 1000;

@Module({ name: "loadingSpinnerStore" })
export class LoadingSpinnerStoreModule extends VuexModule
  implements ILoadingSpinnerState {
  displayTimestamp: number = 0;
  loadingSpinnerConfig: LoadingSpinnerConfig = new LoadingSpinnerConfig();

  @Mutation
  private update_loading_spinner_config(config: LoadingSpinnerConfig) {
    this.loadingSpinnerConfig = config;
  }

  @Mutation
  private set_timestamp() {
    this.displayTimestamp = +new Date();
  }

  @Action
  Show(message: string) {
    this.set_timestamp();
    this.update_loading_spinner_config({
      visible: true,
      message: message,
      state: LoadingState.working
    });
  }

  @Action
  Hide() {
    const newState = new LoadingSpinnerConfig();
    newState.message = this.loadingSpinnerConfig.message;
    newState.visible = false;
    newState.state = this.loadingSpinnerConfig.state;

    var upTime = +new Date() - this.displayTimestamp;

    if (upTime < MIN_UP_TIME_MS) {
      setTimeout(() => {
        this.Hide();
      }, MIN_UP_TIME_MS - upTime);
    } else {
      this.update_loading_spinner_config(newState);
    }
  }

  @Action
  Success(message: string) {
    this.update_loading_spinner_config({
      visible: true,
      message: message,
      state: LoadingState.success
    });

    setTimeout(() => {
      this.Hide();
    }, 2000);
  }

  @Action
  Failure(message: string) {
    this.update_loading_spinner_config({
      visible: true,
      message: message,
      state: LoadingState.failure
    });
  }

  get Visible(): boolean {
    return this.loadingSpinnerConfig.visible;
  }

  get Message(): string {
    return this.loadingSpinnerConfig.message || "";
  }

  get State(): LoadingState {
    return this.loadingSpinnerConfig.state || LoadingState.working;
  }
}
